module.exports = __webpack_public_path__ + "media/images/green note 10-acaba8e37f21e524397ad58c98687246.svg";